import React, { useEffect, useState } from "react"
import { MapMarker, Map } from "react-kakao-maps-sdk";
import moment from 'moment';

// 이미지
import truck from "../../assets/images/truck.png";
import { getTmsData } from "../../crud/tms.crud"
import { getCollectList } from 'crud/auth.crud';

const KakaoMap = () => {
  let interval = null
  const [dataList1, setDataList1] = useState([]);
  const [dataList2, setDataList2] = useState([]);
  const [mergedDataList, setMergedDataList] = useState([]);
  const [center, setCenter] = useState({ lat: 37.54699, lng: 127.09598 });

  const getCompanyDataList = async () => {
    try {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const company = urlParams.get('company') ?? '';
      const date = urlParams.get('date') ?? '';
      const emitter = urlParams.get('emitter') ?? '';

      // date: 'YYYY-MM-DD 00:00:00'
      const today = moment(date).format('YYYY-MM-DD')
      const tomorrow = moment(date)
        .add(1, 'day')
        .format('YYYY-MM-DD');

      const params = {
        driver_company: company,
        company: emitter,
        company_name: '',
        collect_zone: '',
        car: '',
        driver: '',
        start_date: today,
        end_date: tomorrow,
        page: 1,
      };

      const response = await getCollectList(params);
      if (response.status !== 200) return;

      const contents = response.data?.data ?? [];
      if (contents.length === 0) return;

      let sumLat = 0;
      let sumLng = 0;

      const wasteBinCoordinates = contents
        .filter(v => v.state === 'Y')
        .map(({ waste_bin_collect }) => waste_bin_collect?.[0])
        .filter(Boolean)
        .map((bin) => {
          const lat = parseFloat(bin.x);
          const lng = parseFloat(bin.y);

          sumLat += lat;
          sumLng += lng;

          return {
            lat,
            lng,
            markerName: String(bin.id),
          };
        });

      const count = wasteBinCoordinates.length;

      if (count > 0) {
        // setCenter({
        //   lat: sumLat / count,
        //   lng: sumLng / count,
        // });
      }

      setDataList1(wasteBinCoordinates);
    } catch (error) {
      console.error(error);
    }
  };

  const getDataList = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const params = {
      company: urlParams.get('company') || '',
      date: urlParams.get('date') || ''
    }
    const rs = await getTmsData(params)
    if (rs.data?.result === 'success') {
      const tmp = []
      let sumX = 0;
      let sumY = 0;
      let len = rs.data?.data.length
      for (let i = 0; i < len; i++) {
        let data = rs.data?.data[i];
        let item = {
          lat: parseFloat(data.y),
          lng: parseFloat(data.x),
          markerName: data.id + ''
        }
        sumX += parseFloat(data.x);
        sumY += parseFloat(data.y);
        tmp.push(item)
      }
      if (len > 0) {
        setDataList2(tmp)
        // setCenter({ lat: sumY / len, lng: sumX / len })
      }
    }
  }
  
  useEffect(() => {
    const mergedData = [...dataList1, ...dataList2];
    setMergedDataList(mergedData);

    if (mergedData.length === 0) return;

    const { sumLat, sumLng } = mergedData.reduce(
      (acc, { lat, lng }) => {
        acc.sumLat += lat;
        acc.sumLng += lng;
        return acc;
      },
      { sumLat: 0, sumLng: 0 }
    );

    setCenter({
      lat: sumLat / mergedData.length,
      lng: sumLng / mergedData.length,
    });
  }, [dataList1, dataList2]);

  useEffect(() => {
    getDataList()
    getCompanyDataList()
    interval = setInterval(() => {
      getDataList()
      getCompanyDataList()
    }, 15000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <React.Fragment>
      <div className="page-content" style={{ padding: 0 }}>
        <Map center={center} style={{ width: "500px", height: "500px" }}>
          {mergedDataList && mergedDataList.map((item) => {
            return (
              <MapMarker
                key={item.markerName}
                position={{ lat: item.lat, lng: item.lng }}
                image={{
                  src: truck, // 마커이미지의 주소입니다              
                  size: {
                    width: 48,
                    height: 48,
                  }, // 마커이미지의 크기입니다
                  options: {
                    offset: {
                      x: 24,
                      y: 56,
                    }, // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.
                  },
                }}
              >
              </MapMarker>
            )
          })}
        </Map>
      </div>
    </React.Fragment>
  )
}

export default KakaoMap;